<df-header-title></df-header-title>
<df-header-tabs
  [disableAllTabs]="disableAllTabs"
  [tabs]="tabs"
></df-header-tabs>
